import React from 'react';
import './authheader.scss';
import Logo from '../../assets/logo/Anychatlogoff.png';

// Authheader component to display authentication header
const Authheader = () => {
  return (
    <div className='auth-header'>
      {/* Logo section */}
      <div className='logo'>
        <img src={Logo} alt="Logo" />
      </div>
      {/* Text section */}
      <div className='text'>
        <p>Nice to see you here! Please provide your credentials to continue.</p>
      </div>
    </div>
  );
}

export default Authheader;
